import LegalPage from "../../components/LegalPage/LegalPage";

const sections = [
  {
    heading: "Subscription Cancellations",
    paragraphs: [
      "Eligible subscriptions can be cancelled before the next billing cycle begins.",
      "If a renewal has already been processed, the cancellation will apply to future cycles rather than the shipment already in progress.",
    ],
  },
  {
    heading: "Order Changes",
    paragraphs: [
      "We start processing orders quickly, so we cannot guarantee that a recently placed order can be cancelled or changed before fulfillment begins.",
    ],
  },
];

export default function CancellationPolicy() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Cancellation Policy"
      intro="This page explains how order cancellations and subscription cancellations are handled inside the Chill Tree experience."
      lastUpdated="April 14, 2026"
      sections={sections}
    />
  );
}




